import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IMerchantAccount } from "../../../interfaces/IMerchantAccount";
import { IReduxAppState } from "../../../reducers";
import { HTTPMethods } from "../../../yoello-lib/modules/API/API";
import APIExtensions from "../../../yoello-lib/modules/API2/APIDefs";
import { useAPIV2 } from "../../../yoello-lib/modules/API2/useAPIv2";


export function useGetMerchant() {

    const merchant = useSelector((state: IReduxAppState) => state.merchant);
    const [isMerchantLoading , setIsMerchantLoading] = useState<boolean>(true)

    const {  callAPI } = useAPIV2<IMerchantAccount[]>(APIExtensions.merchants,
        { params: { include_disabled: true } , onMountDisabled:true });

    useEffect(()=>{
        if(!merchant || Object.keys(merchant).length === 0){
            callAPI(HTTPMethods.GET).finally(()=>{
                setIsMerchantLoading(false)
            });
        }else{
            setIsMerchantLoading(false);
        }
    // eslint-disable-next-line    
    },[merchant]) 


    return {
        isMerchantLoading,
        merchant
    }
}